/**
 * @generated SignedSource<<ba19497690d7a2572339e68722c7f522>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_SceneDetailQuery$variables = {
  id: string;
};
export type productSidePanelContent_SceneDetailQuery$data = {
  readonly scene: {
    readonly materialMappings: ReadonlyArray<{
      readonly libraryMaterialID: any;
      readonly sceneMaterialID: any;
    }>;
    readonly meshLocations: ReadonlyArray<{
      readonly locationID: any;
      readonly name: string;
    }>;
    readonly shaderMaterials: ReadonlyArray<{
      readonly materialID: any;
      readonly name: string;
    }>;
    readonly sources: ReadonlyArray<{
      readonly rootUrl: string;
      readonly sceneFileName: string;
      readonly sourceID: any;
      readonly url: string;
    }>;
    readonly textures: ReadonlyArray<{
      readonly materialID: any;
    }>;
  };
};
export type productSidePanelContent_SceneDetailQuery = {
  response: productSidePanelContent_SceneDetailQuery$data;
  variables: productSidePanelContent_SceneDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "SceneMeshLocation",
  "kind": "LinkedField",
  "name": "meshLocations",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locationID",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "SceneMaterialMapping",
  "kind": "LinkedField",
  "name": "materialMappings",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sceneMaterialID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "libraryMaterialID",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "materialID",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "SceneShaderMaterial",
  "kind": "LinkedField",
  "name": "shaderMaterials",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "SceneTexture",
  "kind": "LinkedField",
  "name": "textures",
  "plural": true,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "SceneSource",
  "kind": "LinkedField",
  "name": "sources",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rootUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sceneFileName",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_SceneDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Scene",
        "kind": "LinkedField",
        "name": "scene",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_SceneDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Scene",
        "kind": "LinkedField",
        "name": "scene",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4442294552347ed94eec6d49bc5483ee",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_SceneDetailQuery",
    "operationKind": "query",
    "text": "query productSidePanelContent_SceneDetailQuery(\n  $id: String!\n) {\n  scene(id: $id) {\n    meshLocations {\n      locationID\n      name\n    }\n    materialMappings {\n      sceneMaterialID\n      libraryMaterialID\n    }\n    shaderMaterials {\n      materialID\n      name\n    }\n    textures {\n      materialID\n    }\n    sources {\n      sourceID\n      url\n      rootUrl\n      sceneFileName\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ee3e59f04f05287fe190bc4077b2fbbf";

export default node;
